import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";




export default /*@__PURE__*/_defineComponent({
  __name: 'DatenschutzView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Datenschutz" }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "px-base bg-white pt-2 pb-2" }, [
        _createElementVNode("div", { class: "max-w--default mx-auto" }, [
          _createElementVNode("div", { class: "max-w--s mx-auto" }, [
            _createElementVNode("div", { class: "spacing-text" }, [
              _createElementVNode("p", { class: "" }, [
                _createElementVNode("strong", null, "§ 1 Information über die Erhebung personenbezogener Daten")
              ]),
              _createElementVNode("p", { class: "" }, " (1) Im Folgenden informieren wir über die Erhebung personenbezogener Daten bei Nutzung unserer Website. Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z. B. Name, Adresse, E-Mail-Adresse, Nutzerverhalten. "),
              _createElementVNode("p", { class: "" }, [
                _createTextVNode(" (2) Verantwortlicher gem. EU-Datenschutz-Grundverordnung (DS-GVO, (EU) 2016/679) ist Agent 22 GmbH, Kaiser-Wilhelm-Str. 93, 20355 Hamburg, Deutschland (siehe unser Impressum). Unseren externen Datenschutzbeauftragten Herr Christoph Heinrich erreichen Sie unter "),
                _createElementVNode("a", {
                  class: "c-link",
                  href: "mailto:privacy@agent22.eu"
                }, "privacy@agent22.eu"),
                _createTextVNode(" oder unserer Postadresse mit dem Zusatz „der Datenschutzbeauftragte“. ")
              ]),
              _createElementVNode("p", { class: "" }, " (3) Bei Ihrer Kontaktaufnahme mit uns per E-Mail werden die von Ihnen mitgeteilten Daten (Ihre E-Mail-Adresse, ggf. Ihr Name und Ihre Telefonnummer) von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen. "),
              _createElementVNode("p", { class: "" }),
              _createElementVNode("p", { class: "" }, [
                _createElementVNode("strong", null, "§ 2 Ihre Rechte")
              ]),
              _createElementVNode("p", { class: "" }, [
                _createTextVNode(" (1) Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten: "),
                _createElementVNode("br"),
                _createTextVNode("– Recht auf Auskunft, "),
                _createElementVNode("br"),
                _createTextVNode("– Recht auf Berichtigung oder Löschung, "),
                _createElementVNode("br"),
                _createTextVNode("– Recht auf Einschränkung der Verarbeitung, "),
                _createElementVNode("br"),
                _createTextVNode("– Recht auf Widerspruch gegen die Verarbeitung, "),
                _createElementVNode("br"),
                _createTextVNode("– Recht auf Datenübertragbarkeit. ")
              ]),
              _createElementVNode("p", { class: "" }, " (2) Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. "),
              _createElementVNode("p", { class: "" }),
              _createElementVNode("p", { class: "" }, [
                _createElementVNode("strong", null, "§ 3 Erhebung personenbezogener Daten bei Besuch unserer Website")
              ]),
              _createElementVNode("p", { class: "" }, " (1) Bei der bloß informatorischen Nutzung der Website erheben wir nur die personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Wenn Sie unsere Website betrachten möchten, erheben wir die folgenden Daten, die für uns technisch erforderlich sind, um Ihnen unsere Website anzuzeigen und die Stabilität und Sicherheit zu gewährleisten: "),
              _createElementVNode("p", { class: "" }, [
                _createTextVNode(" – IP-Adresse "),
                _createElementVNode("br"),
                _createTextVNode("– Datum und Uhrzeit der Anfrage "),
                _createElementVNode("br"),
                _createTextVNode("– Zeitzonendifferenz zur Greenwich Mean Time (GMT) "),
                _createElementVNode("br"),
                _createTextVNode("– Inhalt der Anforderung (konkrete Seite) "),
                _createElementVNode("br"),
                _createTextVNode("– Zugriffsstatus/HTTP-Statuscode "),
                _createElementVNode("br"),
                _createTextVNode("– jeweils übertragene Datenmenge "),
                _createElementVNode("br"),
                _createTextVNode("– Website, von der die Anforderung kommt "),
                _createElementVNode("br"),
                _createTextVNode("– Browser "),
                _createElementVNode("br"),
                _createTextVNode("– Betriebssystem und dessen Oberfläche "),
                _createElementVNode("br"),
                _createTextVNode("– Sprache und Version der Browsersoftware. ")
              ]),
              _createElementVNode("p", { class: "" }, " (2) Zusätzlich zu den zuvor genannten Daten werden bei Ihrer Nutzung unserer Website Cookies auf Ihrem Rechner gespeichert. Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrer Festplatte dem von Ihnen verwendeten Browser zugeordnet gespeichert werden und durch welche der Stelle, die den Cookie setzt (hier durch uns), bestimmte Informationen zufließen. Cookies können keine Programme ausführen oder Viren auf Ihren Computer übertragen. Sie dienen dazu, das Internetangebot insgesamt nutzerfreundlicher und effektiver zu machen. "),
              _createElementVNode("p", { class: "" }, " (3) Einsatz von Cookies: "),
              _createElementVNode("p", { class: "" }, [
                _createTextVNode(" a) Diese Website nutzt folgende Arten von Cookies, deren Umfang und Funktionsweise im Folgenden erläutert werden: "),
                _createElementVNode("br"),
                _createTextVNode("– Transiente Cookies (dazu b) "),
                _createElementVNode("br"),
                _createTextVNode("– Persistente Cookies (dazu c). ")
              ]),
              _createElementVNode("p", { class: "" }, " b) Transiente Cookies werden automatisiert gelöscht, wenn Sie den Browser schließen. Dazu zählen insbesondere die Session-Cookies. Diese speichern eine sogenannte Session-ID, mit welcher sich verschiedene Anfragen Ihres Browsers der gemeinsamen Sitzung zuordnen lassen. Dadurch kann Ihr Rechner wiedererkannt werden, wenn Sie auf unsere Website zurückkehren. Die Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder den Browser schließen. "),
              _createElementVNode("p", { class: "" }, " c) Persistente Cookies werden automatisiert nach einer vorgegebenen Dauer gelöscht, die sich je nach Cookie unterscheiden kann. Sie können die Cookies in den Sicherheitseinstellungen Ihres Browsers jederzeit löschen. "),
              _createElementVNode("p", { class: "" }, " d) Sie können Ihre Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und z. B. die Annahme aller Cookies ablehnen. Wir weisen Sie darauf hin, dass Sie eventuell nicht alle Funktionen dieser Website nutzen können. ")
            ])
          ])
        ])
      ], -1),
      _createElementVNode("div", { class: "px-base bg-white mb-5 pt-2 pb-2" }, [
        _createElementVNode("div", { class: "max-w--default mx-auto" }, [
          _createElementVNode("div", { class: "max-w--s mx-auto" }, [
            _createElementVNode("div", { class: "spacing-text" }, [
              _createElementVNode("p", { class: "" }, [
                _createElementVNode("strong", null, "Gelegentlich müssen wir unsere Datenschutzerklärung aktualisieren. Die neueste Version der Datenschutzerklärung ist immer auf unserer Website verfügbar. Wir informieren Sie über alle wesentlichen Änderungen an der Datenschutzerklärung, zum Beispiel die Verwendung Ihrer personenbezogenen Daten, die verantwortliche Person für die Datenverarbeitung oder Ihre Rechte.")
              ])
            ])
          ])
        ])
      ], -1)
    ]))]),
    _: 1
  }))
}
}

})